export enum ChangelogEnum {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  FIXED = 'FIXED',
  SECURITY = 'SECURITY',
  DEPRECATED = 'DEPRECATED',
  REMOVED = 'REMOVED',
}
